var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eligibility-reasons" }, [
    _vm.notEligible
      ? _c("h3", { staticClass: "title" }, [
          _vm._v("\n    Not eligible for " + _vm._s(_vm.service) + "\n  "),
        ])
      : _c("strong", [
          _vm._v(
            "\n    Device is eligible for " + _vm._s(_vm.service) + "\n  "
          ),
        ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "reasons-list" },
      _vm._l(_vm.reasons, function (reason, index) {
        return _c("li", { key: index, staticClass: "reason-item" }, [
          _vm._v("\n      " + _vm._s(reason) + "\n    "),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }